import api from './api';

class StationService {
  // Generate a unique station ID based on browser/session
  getStationId() {
    let stationId = localStorage.getItem('stationId');
    if (!stationId) {
      // Generate a unique ID based on timestamp and random number
      stationId = `station_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      localStorage.setItem('stationId', stationId);
    }
    return stationId;
  }

  // Get current station status
  async getStationStatus(bookingId, stationId = null) {
    try {
      const id = stationId || this.getStationId();
      const params = bookingId ? `?bookingId=${bookingId}` : '';
      const response = await api.get(`/stations/status/${id}${params}`);
      console.log('Station status response:', response.data);
      return {
        success: true,
        data: response.data.success ? response.data.data : response.data
      };
    } catch (error) {
      console.error('Error fetching station status:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch station status'
      };
    }
  }

  // Update station status
  async updateStationStatus(action, bookingId, options = {}) {
    try {
      const stationId = this.getStationId();
      const response = await api.post(`/stations/status/${stationId}`, {
        action,
        bookingId,
        ...options
      });
      console.log('Station status update response:', response.data);
      return {
        success: true,
        data: response.data.success ? response.data.data : response.data
      };
    } catch (error) {
      console.error('Error updating station status:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to update station status'
      };
    }
  }

  // Start screening for a patient
  async startScreening(bookingId, patientId, staffId = null, timerDuration = null) {
    return this.updateStationStatus('start_screening', bookingId, {
      patientId,
      staffId,
      timerDuration
    });
  }

  // Complete screening (triggers timer)
  async completeScreening(bookingId) {
    return this.updateStationStatus('complete_screening', bookingId);
  }

  // Mark station as available
  async markAvailable(bookingId) {
    return this.updateStationStatus('mark_available', bookingId);
  }

  // Auto cleanup when timer expires
  async autoCleanup(bookingId) {
    return this.updateStationStatus('auto_cleanup', bookingId);
  }

  // Get all station statuses (for admin view)
  async getAllStations() {
    try {
      const response = await api.get('/stations/all');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error fetching all stations:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch stations'
      };
    }
  }

  // Update station name
  async updateStationName(stationName, stationId = null) {
    try {
      const id = stationId || this.getStationId();
      const response = await api.put(`/stations/name/${id}`, { stationName });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error updating station name:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to update station name'
      };
    }
  }
}

export default new StationService();
